import React, { useState, useEffect } from "react";
// import routes from "./routes";
import { useNavigate, useLocation } from "react-router-dom";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { Popover, Tooltip } from "antd";
import { AppRoute } from "./routes";
const SidebarMenu = ({ collapsed ,  routes }: { collapsed?: boolean ,  routes? : AppRoute[] }) => {
  const [activeParent, setActiveParent] = useState<number | null>(null);
  const [activeChild, setActiveChild] = useState<string | null>(null);
  const [openDropdown, setOpenDropdown] = useState<number | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  // Set active based on current URL on mount or path change
  useEffect(() => {
    const currentPath = location.pathname;
    routes?.forEach((item: any, index: number) => {
      if (item?.children?.length > 0) {
        item?.children.forEach((child: any) => {
          const fullPath =
            (item.url?.endsWith("/") ? item.url : item.url + "/") +
            (child.url?.startsWith("/") ? child.url.slice(1) : child.url);
          if (fullPath === currentPath) {
            setActiveParent(index);
            setActiveChild(child.key);
            setOpenDropdown(index);
          }
        });
      } else if (item.url === currentPath) {
        setActiveParent(index);
        setActiveChild(null);
      }
    });
  }, [location.pathname]);
  const handleParentClick = (item: any, index: number, hasChildren: boolean) => {
    setActiveParent(index);
    setActiveChild(null);
    if (hasChildren) {
      setOpenDropdown(openDropdown === index ? null : index);
    } else if (item.url) {
      navigate(item.url);
    }
  };
  const handleChildClick = (child: any, parentIndex: number) => {
    const parent = routes &&  routes[parentIndex];
    setActiveParent(parentIndex);
    setActiveChild(child.key);
    const parentURL = parent?.url || "";
    const childURL = child?.url || "";
    const finalURL =
      parentURL.endsWith("/") || childURL.startsWith("/")
        ? parentURL + childURL
        : `${parentURL}/${childURL}`;
    navigate(finalURL);
  };



  return (
    <ul className="sidebar">
      {routes?.map((item: any, index: number) => {
        const hasChildren = item?.children?.length > 0;
        const isParentActive =
          activeParent === index ||
          item.children?.some((c: any) => c.key === activeChild);
        // COLLAPSED MODE
        if (collapsed) {
          if (hasChildren) {
            // Popover for items with children
            return (
              <Popover
                key={item.key}
                placement="right"
                trigger="click"
                content={
                  <ul className="flex flex-col gap-2">
                    {item.children.map((child: any) => (
                      <li
                        key={child.key}
                        onClick={() => handleChildClick(child, index)}
                        className={`cursor-pointer px-3 py-1 rounded hover:bg-gray-100 hover:text-blue-600 ${
                          activeChild === child.key
                            ? "text-blue-600 font-semibold"
                            : "text-black"
                        }`}
                      >
                        {child.label}
                      </li>
                    ))}
                  </ul>
                }
              >
                <li
                  className={`${isParentActive ? "active" : ""} flex items-center gap-2 cursor-pointer p-2`}
                >
                  {item.icon && <item.icon className="w-5 h-5" />}
                </li>
              </Popover>
            );
          } else {
            // Tooltip for items without children
            return (
              <Tooltip key={item.key} title={item.label} placement="right">
                <li
                  className={`${isParentActive ? "active" : ""} flex items-center gap-2 cursor-pointer p-2`}
                  onClick={() => handleParentClick(item, index, false)}
                >
                  {item.icon && <item.icon className="w-5 h-5" />}
                </li>
              </Tooltip>
            );
          }
        }
        // EXPANDED MODE
        return (
          <React.Fragment key={item.key}>
            <li
              className={`${isParentActive ? "active" : ""} flex items-center gap-2 relative cursor-pointer`}
              onClick={() => handleParentClick(item, index, hasChildren)}
            >
              <span className="flex text-[16px]  gap-2">
                {item.icon && <item.icon className="w-[20px] h-[20px]" />}
                {!collapsed && item.label}
              </span>
              {!collapsed && hasChildren && (
                <span className="ml-auto absolute right-5 top-1/3">
                  {openDropdown === index ? <UpOutlined /> : <DownOutlined />}
                </span>
              )}
            </li>
            {hasChildren && openDropdown === index && !collapsed && (
              <ul className="pl-9">
                {item.children.map((child: any) => {
                  const isChildActive = activeChild === child.key;
                  return (
                    <li
                      key={child.key}
                      onClick={() => handleChildClick(child, index)}
                      className={`py-2 cursor-pointer ${
                        isChildActive
                          ? "bg-white rounded-l-full !text-primary font-semibold"
                          : "text-white"
                      }`}
                    >
                      {child.label}
                    </li>
                  );
                })}
              </ul>
            )}
          </React.Fragment>
        );
      })}
    </ul>
  );
};
export default SidebarMenu;